/* PENGINEER customer reviews V1.1: dependency-free, lazy loaded, read-only. Public export fields only.
   Data rows: id, rating, review_date, text, size_used, dog_weight_kg, back_length_cm, chest_girth_cm, head_circumference_cm,
   follow_up_of, display_mode, product_model, product_relationship, review_type. */
(function (root) {
  'use strict';
  var FACTS = [['size_used', 'Size ', ''], ['dog_weight_kg', '', ' kg'], ['back_length_cm', 'Back ', ' cm'], ['chest_girth_cm', 'Chest ', ' cm'], ['head_circumference_cm', 'Head ', ' cm']];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function dateKey(r) { return r.review_date || ''; }

  // Group rows into chains: an initial review with its follow-ups. Suppressed duplicates are never in the data; a chain-only (recovered) initial is
  // shown only together with a follow-up; orphan follow-ups (initial not displayed) stand on their own.
  function buildChains(rows) {
    var byId = {}, kids = {}, i;
    for (i = 0; i < rows.length; i++) { byId[rows[i].id] = rows[i]; }
    var top = [];
    for (i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r.display_mode === 'display_once_suppressed') { continue; }
      if (r.follow_up_of && byId[r.follow_up_of]) { (kids[r.follow_up_of] = kids[r.follow_up_of] || []).push(r); } else { top.push(r); }
    }
    var chains = [];
    for (i = 0; i < top.length; i++) {
      var head = top[i], f = (kids[head.id] || []).slice().sort(function (a, b) { return dateKey(a) < dateKey(b) ? -1 : dateKey(a) > dateKey(b) ? 1 : (a.id < b.id ? -1 : 1); });
      if (head.display_mode === 'chain_only' && f.length === 0) { continue; } // recovered initials are never standalone
      var latest = dateKey(head);
      for (var j = 0; j < f.length; j++) { if (dateKey(f[j]) > latest) { latest = dateKey(f[j]); } }
      chains.push({ head: head, follow: f, latest: latest });
    }
    chains.sort(function (a, b) { return a.latest < b.latest ? 1 : a.latest > b.latest ? -1 : (a.head.id < b.head.id ? -1 : 1); });
    return chains;
  }

  function fmtDate(s) {
    var m = /^(\d{4})-(\d{2})/.exec(s || '');
    return m ? MONTHS[parseInt(m[2], 10) - 1] + ' ' + m[1] : '';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text != null) { n.textContent = text; }
    return n;
  }

  // Shared "find similar dogs" engine. A mode names the measurements that matter; ABUBA uses body measures, KYUNGLAS can later add a
  // 'head' mode (weight + head circumference + size used) with the same markup, filters and case cards.
  var MODES = {
    body: {
      filters: [
        { key: 'dog_weight_kg', label: 'Dog Weight', unit: ' kg', step: 3, primary: true },
        { key: 'size_used', label: 'Size Used', primary: true, categorical: true },
        { key: 'back_length_cm', label: 'Back Length', unit: ' cm', step: 5 },
        { key: 'chest_girth_cm', label: 'Chest Girth', unit: ' cm', step: 5 }
      ]
    },
    head: {
      filters: [
        { key: 'dog_weight_kg', label: 'Dog Weight', unit: ' kg', step: 3, primary: true },
        { key: 'head_circumference_cm', label: 'Head Circumference', unit: ' cm', step: 2, primary: true },
        { key: 'size_used', label: 'Size Used', primary: true, categorical: true }
      ]
    }
  };
  var CHIPS = [['dog_weight_kg', '', ' kg', true], ['size_used', 'Size ', '', true], ['back_length_cm', 'Back ', ' cm', false], ['chest_girth_cm', 'Chest ', ' cm', false], ['head_circumference_cm', 'Head ', ' cm', false]];
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

  function has(v) { return v !== undefined && v !== null && String(v).trim() !== ''; }

  function hasMeasure(r, mode) {
    var f = MODES[mode].filters;
    for (var i = 0; i < f.length; i++) { if (f[i].primary && has(r[f[i].key])) { return true; } }
    return false;
  }

  function bucket(f, v) {
    var n = parseFloat(v);
    if (isNaN(n)) { return null; }
    var lo = Math.floor(n / f.step) * f.step;
    return lo;
  }

  function bucketLabel(f, lo) { return lo + '–' + (lo + f.step) + f.unit; }

  function chips(r) {
    var ul = el('ul', 'pgr__facts');
    for (var k = 0; k < CHIPS.length; k++) {
      var v = r[CHIPS[k][0]];
      if (has(v)) { ul.appendChild(el('li', 'pgr__fact' + (CHIPS[k][3] ? ' is-primary' : ''), CHIPS[k][1] + String(v).trim() + CHIPS[k][2])); }
    }
    return ul.childNodes.length ? ul : null;
  }

  function card(r, isFollow, withChips, src) {
    var c = el('article', 'pgr__card');
    var top = el('div', 'pgr__top');
    var n = parseInt(r.rating, 10);
    if (n >= 1 && n <= 5) {
      var st = el('span', 'pgr__rs');
      st.setAttribute('role', 'img');
      st.setAttribute('aria-label', n + ' out of 5 stars');
      for (var i = 1; i <= 5; i++) { var s = el('span', i <= n ? '' : 'is-off', '★'); s.setAttribute('aria-hidden', 'true'); st.appendChild(s); }
      top.appendChild(st);
    }
    var d = fmtDate(r.review_date);
    if (d) { top.appendChild(el('span', 'pgr__date', d)); }
    if (isFollow && r.review_type === 'one_month_use') { top.appendChild(el('span', 'pgr__kicker', 'One-month update')); }
    if (top.childNodes.length) { c.appendChild(top); }
    if (r.product_relationship === 'predecessor_generation' && r.product_model) {
      c.appendChild(el('span', 'pgr__tag', 'Previous ' + r.product_model + ' generation'));
    } else if (src && r.product_model) {
      c.appendChild(el('span', 'pgr__tag', r.product_model)); // shared pool: which model the review came from (provenance only)
    }
    c.appendChild(el('p', 'pgr__text', r.text || ''));
    var ch = withChips === false ? null : chips(r);
    if (ch) { c.appendChild(ch); }
    return c;
  }

  function chainNode(ch, src) {
    var li = el('li', 'pgr__chain');
    li.appendChild(card(ch.head, false, true, src));
    if (ch.follow.length) {
      var ol = el('ol', 'pgr__follow');
      for (var i = 0; i < ch.follow.length; i++) { var fi = el('li'); fi.appendChild(card(ch.follow[i], true, true, src)); ol.appendChild(fi); }
      li.appendChild(ol);
    }
    return li;
  }

  // A size case is facts only (no review text): date, generation tag, measurement chips.
  function caseNode(r) {
    var li = el('li', 'pgr__case');
    var c = el('article', 'pgr__card');
    var d = fmtDate(r.review_date);
    if (d) { var top = el('div', 'pgr__top'); top.appendChild(el('span', 'pgr__date', d)); c.appendChild(top); }
    if (r.product_relationship === 'predecessor_generation' && r.product_model) { c.appendChild(el('span', 'pgr__tag', 'Previous ' + r.product_model + ' generation')); }
    var ch = chips(r);
    if (ch) { c.appendChild(ch); }
    li.appendChild(c);
    return li;
  }

  // Filter model: returns [{def, options:[{value,label}]}] built from the rows that carry that measurement.
  function filterModel(rows, mode) {
    var out = [];
    MODES[mode].filters.forEach(function (f) {
      var seen = {}, opts = [];
      rows.forEach(function (r) {
        if (!has(r[f.key])) { return; }
        var v = f.categorical ? String(r[f.key]).trim() : bucket(f, r[f.key]);
        if (v === null || seen[v] !== undefined) { return; }
        seen[v] = 1;
        opts.push({ value: String(v), label: f.categorical ? v : bucketLabel(f, v), sort: f.categorical ? (SIZE_ORDER.indexOf(v) < 0 ? 99 : SIZE_ORDER.indexOf(v)) : v });
      });
      opts.sort(function (a, b) { return a.sort < b.sort ? -1 : a.sort > b.sort ? 1 : 0; });
      if (opts.length) { out.push({ def: f, options: opts }); }
    });
    return out;
  }

  function matches(r, sel, model) {
    for (var i = 0; i < model.length; i++) {
      var f = model[i].def, want = sel[f.key];
      if (!want) { continue; }
      if (!has(r[f.key])) { return false; }
      var v = f.categorical ? String(r[f.key]).trim() : String(bucket(f, r[f.key]));
      if (v !== want) { return false; }
    }
    return true;
  }

  function mount(host) {
    var files = (host.getAttribute('data-pgr-files') || '').split(',').filter(Boolean);
    var caseFiles = (host.getAttribute('data-pgr-case-files') || '').split(',').filter(Boolean);
    var first = parseInt(host.getAttribute('data-pgr-first'), 10) || 3;
    var step = parseInt(host.getAttribute('data-pgr-step'), 10) || 3;
    var mode = host.getAttribute('data-pgr-mode') || '';
    var source = host.getAttribute('data-pgr-source') === '1';
    if (!MODES[mode]) { mode = ''; }
    var toggle = host.querySelector('[data-pgr-toggle]');
    var panel = host.querySelector('[data-pgr-panel]');
    var list = host.querySelector('[data-pgr-list]');
    var more = host.querySelector('[data-pgr-more]');
    var status = host.querySelector('[data-pgr-status]');
    var cases = host.querySelector('[data-pgr-cases]');
    var casesMore = host.querySelector('[data-pgr-cases-more]');
    var casesNote = host.querySelector('[data-pgr-cases-note]');
    var filtersEl = host.querySelector('[data-pgr-filters]');
    var rows = [], allCases = [], chains = [], model = [], sel = {}, caseRows = [], shown = 0, caseShown = 0;
    var loaded = false, loading = false, expanded = false, rendered = false;

    function paintChains(n) {
      var end = Math.min(chains.length, shown + n), frag = document.createDocumentFragment();
      for (; shown < end; shown++) { frag.appendChild(chainNode(chains[shown], source)); }
      list.appendChild(frag);
      more.hidden = chains.length - shown <= 0;
    }

    function paintCases(reset) {
      if (!cases) { return; }
      if (reset) { cases.textContent = ''; caseShown = 0; }
      var end = Math.min(caseRows.length, caseShown + (reset ? first : step)), frag = document.createDocumentFragment();
      for (; caseShown < end; caseShown++) { frag.appendChild(caseNode(caseRows[caseShown])); }
      cases.appendChild(frag);
      casesMore.hidden = caseRows.length - caseShown <= 0;
      casesNote.hidden = caseRows.length > 0;
      casesNote.textContent = caseRows.length ? '' : 'No size references match these measurements yet. Try fewer filters.';
    }

    function applyFilters() {
      caseRows = allCases.filter(function (r) { return matches(r, sel, model); })
        .sort(function (a, b) { return dateKey(a) < dateKey(b) ? 1 : dateKey(a) > dateKey(b) ? -1 : 0; });
      paintCases(true);
    }

    function selectField(m) {
      var wrap = el('label', 'pgr__field', m.def.label);
      var s = el('select', 'pgr__select');
      s.appendChild(el('option', '', 'Any'));
      s.firstChild.value = '';
      m.options.forEach(function (o) { var op = el('option', '', o.label); op.value = o.value; s.appendChild(op); });
      s.addEventListener('change', function () { if (s.value) { sel[m.def.key] = s.value; } else { delete sel[m.def.key]; } applyFilters(); });
      wrap.appendChild(s);
      return wrap;
    }

    function buildFilters() {
      if (!filtersEl) { return; }
      var secondary = el('div', 'pgr__filters');
      model.forEach(function (m) { (m.def.primary ? filtersEl : secondary).appendChild(selectField(m)); });
      if (secondary.childNodes.length) {
        var d = el('details', 'pgr__morefilters');
        d.appendChild(el('summary', '', 'More filters'));
        d.appendChild(secondary);
        filtersEl.appendChild(d);
      }
    }

    function render() {
      if (rendered || !loaded || !expanded) { return; }
      rendered = true;
      status.hidden = true;
      if (mode) { model = filterModel(allCases, mode); buildFilters(); applyFilters(); }
      paintChains(first);
    }

    function start() {
      if (loaded || loading) { return; }
      loading = true;
      if (expanded) { status.hidden = false; }
      var get = function (u) { return fetch(u, { credentials: 'omit' }).then(function (r) { if (!r.ok) { throw new Error('http ' + r.status); } return r.json(); }); };
      Promise.all([Promise.all(files.map(get)), Promise.all(mode ? caseFiles.map(get) : [])])
        .then(function (both) {
          var parts = both[0];
          both[1].forEach(function (p) { allCases = allCases.concat(p.cases || []); });
          parts.forEach(function (p) { rows = rows.concat(p.reviews || []); });
          chains = buildChains(rows);
          loaded = true;
          render();
        })
        .catch(function () { loading = false; if (expanded) { status.textContent = 'Reviews could not be loaded right now.'; status.hidden = false; } });
    }

    toggle.addEventListener('click', function () {
      expanded = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.hidden = !expanded;
      if (expanded) { if (loaded) { render(); } else { start(); status.hidden = false; } }
    });
    more.addEventListener('click', function () { paintChains(step); });
    if (casesMore) { casesMore.addEventListener('click', function () { paintCases(false); }); }

    // Data is prefetched near the viewport (the summary sits under the buy box, so this is almost immediate) but cards render only after expansion.
    if ('IntersectionObserver' in root) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
      io.observe(host);
      // Fallback: observers can stay silent in background tabs / print / embedded views. The data files are small, so load shortly after page load.
      var kick = function () { root.setTimeout(start, 2500); };
      if (document.readyState === 'complete') { kick(); } else { root.addEventListener('load', kick); }
    } else { start(); }
  }

  function init() {
    var hosts = document.querySelectorAll('[data-pgr]');
    for (var i = 0; i < hosts.length; i++) { mount(hosts[i]); }
  }

  var api = { buildChains: buildChains, fmtDate: fmtDate, filterModel: filterModel, matches: matches, hasMeasure: hasMeasure, MODES: MODES };
  root.PengineerReviews = api;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  }
})(typeof window !== 'undefined' ? window : globalThis);
